/**
 * 
 */


export function getEmailActivationMsg(){
	return "An email has been sent to confirm your registration via the email address provided."+ 
	  " Please complete the steps provided in the email. "+
	  "If you do not receive an email, consider your SPAM folders.";
} 